let SOCAIL_CAROUSEL_CURR_VIDEO = null;
let SOCAIL_CAROUSEL_CURR_VIDEO_CONTROLS = null;

function getCurrPlayingVideo() {
  return SOCAIL_CAROUSEL_CURR_VIDEO;
}

function setCurrPlayingVideo(video) {
  SOCAIL_CAROUSEL_CURR_VIDEO = video;
}

function getCurrVideoControls() {
  return SOCAIL_CAROUSEL_CURR_VIDEO_CONTROLS;
}

function setCurrControls(controls) {
  SOCAIL_CAROUSEL_CURR_VIDEO_CONTROLS = controls;
}

function loadVideoPromise(videoEl) {
    return new Promise((resolve, reject) => {
        const onLoaded = () => {
            cleanup();
            resolve(true);
        };

        const onError = () => {
            cleanup();
            reject(new Error("Video failed to load or has no supported source."));
        };

        const cleanup = () => {
            videoEl.removeEventListener("loadedmetadata", onLoaded);
            videoEl.removeEventListener("error", onError);
        };

        videoEl.addEventListener("loadedmetadata", onLoaded);
        videoEl.addEventListener("error", onError);

        videoEl.load();
    });
}

function setSocialVideo({ bannerId, videoId, dtSrc, mewSrc, posterSrc }) {
    console.log(">>>>>>>Video",bannerId, videoId);
    const video = document.querySelector(`#${videoId}`);
    if (!video) return;

    const closestCard = video;
    const playPuaseButton = document.querySelector(`#${bannerId} .${videoId} .play-pause`);
    const muteUnmuteButton = document.querySelector(`#${bannerId} .${videoId} .mute-unmute`);

    function setPoster() {
        video.poster = posterSrc;
    }

    function setVideoSrc() {
        video.src = dtSrc;
    }

    function loadVideo() {
        loadVideoPromise(video)
            .then(() => {
                muteUnmuteButton.disabled = false;
                playPuaseButton.setAttribute("aria-disabled", false);
            })
            .catch((err) => {
                muteUnmuteButton.disabled = true;
                playPuaseButton.setAttribute("aria-disabled", true);
                console.error(err.message);
            });
    }

    function setAnimationControls() {
        function isVideoSrcSupported() {
            return !video.error;
        }

        function playVideo(button) {
            video.play();
            button.classList.add("playing");
            button.setAttribute("aria-label", "pause");
        }

        function pauseVideo(button) {
            video.pause();
            button.classList.remove("playing");
            button.setAttribute("aria-label", "play");
        }

        function audioActionEvent(e) {
            e.preventDefault();
            if (video.muted) {
                muteUnmuteButton.setAttribute("data-state", "unmute");
            } else {
                muteUnmuteButton.setAttribute("data-state", "mute");
            }
            video.muted = !video.muted;
        }

        closestCard.addEventListener("mouseenter", () => {
            if (isVideoSrcSupported()) playVideo(playPuaseButton);
        });

        closestCard.addEventListener("mouseout", () => {
            if (isVideoSrcSupported()) pauseVideo(playPuaseButton);
        });

        playPuaseButton.addEventListener("click", function (event) {
            if (!isVideoSrcSupported()) return;
            event.preventDefault();

            // Only one video playing at a time
            if (video.paused) {
                if (getCurrPlayingVideo()) getCurrPlayingVideo().pause();
                if (getCurrVideoControls()) pauseVideo(getCurrVideoControls());
                setCurrPlayingVideo(video);
                setCurrControls(playPuaseButton);
                playVideo(playPuaseButton);
            } else {
                setCurrPlayingVideo(null);
                setCurrControls(null);
                pauseVideo(playPuaseButton);
            }
        });

        playPuaseButton.addEventListener("keyup", function (event) {
            if (!isVideoSrcSupported()) return;
            event.preventDefault();
            if (event.keyCode === 13) {
                this.click();
            } else if (event.keyCode === 32) {
                this.click();
            }
        });

        muteUnmuteButton.addEventListener("click", audioActionEvent);
        muteUnmuteButton.addEventListener("tap", audioActionEvent);
    }

    setPoster();
    setVideoSrc();
    loadVideo();
    setAnimationControls(bannerId, videoId);
}

module.exports = {
  setSocialVideo
};

/** 
 * 
 * Back up code for having different videos for DT/MEW.
 * 
    function handleVideoResize(sectionId, videoId) {
      const videoControls = document.querySelector(`#${sectionId} .${videoId} .video-controls`);
      const video = document.querySelector(`#${videoId}`);

      // Load new video
      if (window.innerWidth < 720) {
        video.src = mewUrl;
      } else {
        video.src = dtUrl;
      }
      video.load();
      videoControls.classList.add("playing");
      video.play();
    }

    // Handle Window Resize
    let isMobile = window.innerWidth < 720 ? true : false;
    window.addEventListener("resize", () => {
      if (window.innerWidth < 720 && isMobile) return;
      if (window.innerWidth >= 720 && !isMobile) return;
      isMobile = window.innerWidth < 720 ? true : false;
      handleVideoResize(bannerId, videoId);
    });
*/
